var render = function(_h, _vm) {
  var _c = _vm._c
  return _c("img", {
    staticStyle: { width: "100%", height: "100%" },
    attrs: { src: require("@/static/svg/perfil_hombre.svg"), alt: "next" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }